import { ITEM_SLOT } from '@shared/constants/items.constant';

export const heroItemSlotTypes: number[] = [
  ITEM_SLOT.HEAD,
  ITEM_SLOT.BODY,
  ITEM_SLOT.BOOTS,
  ITEM_SLOT.GLOVES,
  ITEM_SLOT.BELT,
  //------
  ITEM_SLOT.RIGHT_HAND,
  ITEM_SLOT.LEFT_HAND,
  ITEM_SLOT.LEFT_RING,
  ITEM_SLOT.RIGHT_RING,
  ITEM_SLOT.AMULET,
  //-------
  ITEM_SLOT.SKILL_1,
  ITEM_SLOT.SKILL_2,
  ITEM_SLOT.SKILL_3,
];
